// extracted by mini-css-extract-plugin
export default {"mobileStore":"MobileStore_mobileStore__ZlJFK"};